/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : DELETE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    toggle: {
        cursor: 'pointer',
        textAlign: 'center',
        width: pxToEm(16),
        height: pxToEm(16),
        position: 'relative',
        top: pxToEm(1),
        left: '85%',
        zIndex: '10',
        transition: 'filter .2s linear 0s',
        fontSize: '115%',
        '& .remove': {
            color: '#DF1D1D'
        },
        '& .add': {
            color: '#5F9E19'
        },
        '&:hover': {
            filter: 'brightness(85%)'
        }
    }
});